import {Button, Container, Form} from "react-bootstrap";
import FormTitle from "../components/FormTitle";
import Footer from "../components/Footer";
import FormHeader from "../components/FormHeader";

const KitchenSink = () => {
    return (
        <>
            <Container className="px-0">
                <FormHeader/>
                <FormTitle title="KitchenSink"/>
                <div className="bg-light p-4 mb-4">
                    <h4 className="mb-4">Buttons</h4>
                    <div className="mb-3 d-flex gap-2">
                        <Button variant="primary">Primary</Button>
                        <Button variant="secondary">Secondary</Button>
                        <Button variant="danger">Danger</Button>
                        <Button variant="dark">Dark</Button>
                        <Button variant="light">Light</Button>
                    </div>
                    <div className="mb-5 d-flex gap-2">
                        <Button variant="outline-primary">Outline Primary</Button>
                        <Button variant="outline-secondary">Outline Secondary</Button>
                        <Button variant="outline-danger">Outline Danger</Button>
                        <Button variant="outline-dark">Outline Dark</Button>
                        <Button variant="outline-light">Outline Light</Button>
                    </div>

                    <h4 className="mb-4">Form fields</h4>
                    <Form>
                        <Form.Group className="mb-4">
                            <Form.Label>Text Field</Form.Label>
                            <Form.Control type="text" placeholder="Text Field" isInvalid/>
                            <Form.Control.Feedback type="invalid">Some error!</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label>Text Field 2</Form.Label>
                            <Form.Control type="text" placeholder="Text Field" isValid/>
                            <Form.Control.Feedback type="valid">Looks Good!</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label>Textarea</Form.Label>
                            <Form.Control as="textarea" rows={3}/>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label>Select</Form.Label>
                            <Form.Select aria-label="Default select example">
                                <option>Open this select menu</option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-4">
                            <Form.Label>File input</Form.Label>
                            <Form.Control type="file"/>
                        </Form.Group>
                        <div className="mb-4">
                            <Form.Check
                                type="checkbox"
                                id="default-checkbox"
                                label="Checkbox"
                            />
                        </div>
                        <div className="mb-4">
                            <Form.Check
                                type="radio"
                                id="default-radio"
                                label="Radio"
                            />
                        </div>
                        <div className="d-flex justify-content-center gap-3 mt-4">
                            <Button variant="outline-dark" type="reset" className="px-4">Cancel</Button>
                            <Button variant="primary" type="submit" className="px-4">Submit</Button>
                        </div>
                    </Form>
                </div>
            </Container>
            <Footer nav={false}/>
        </>
    )
}

export default KitchenSink;
